import React, { Component } from "react";
import _ from "lodash";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { Dialog, FlatButton, IconButton } from "material-ui";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import People from "material-ui/svg-icons/social/people";
import Gear from "material-ui/svg-icons/action/settings";
import Help from "material-ui/svg-icons/action/help";
import Message from "material-ui/svg-icons/communication/message";
import Restaurant from "material-ui/svg-icons/maps/restaurant";
import SentimentVerySatisfied from "material-ui/svg-icons/social/sentiment-very-satisfied";
import DashboardIcon from "material-ui/svg-icons/action/dashboard";
import ItemFeedbacksIcon from "material-ui/svg-icons/content/reply";
import MenuIcon from "material-ui/svg-icons/action/chrome-reader-mode";
import Menu from "material-ui/svg-icons/navigation/menu";
import Alert from "material-ui/svg-icons/alert/add-alert";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import { translate } from "react-i18next";
import moment from "moment";
import "moment/locale/ru";
import styled from "styled-components";

import "./App.css";
import { GiftsHint, TryHint } from "./hints";
import AsapAppBar from "./components/AsapAppBar";
import AsapAvatar from "./components/AsapAvatar";
import AsapDrawer from "./components/AsapDrawer";
import AsapPicker from "./components/AsapPicker";
import NavigationMenu from "./components/NavigationMenu";
import DashboardEventFeed from "./containers/Dashboard/DashboardEventFeed";
import SupportChat from "./containers/SupportChat/SupportChat";
import asyncComponentLoader from "./asyncComponentLoader";
import { pompadour } from "./colors";

const LunchConstructor = asyncComponentLoader(() =>
  import(/* webpackChunkName: "LunchConstructor" */ "./components/LunchConstructor"));
const Editor = asyncComponentLoader(() =>
  import(/* webpackChunkName: "Editor" */ "./components/Editor"));
const Guests = asyncComponentLoader(() =>
  import(/* webpackChunkName: "Guests" */ "./containers/Guests/Guests"));
const LunchList = asyncComponentLoader(() =>
  import(/* webpackChunkName: "LunchList" */ "./components/LunchList"));
const Login = asyncComponentLoader(() =>
  import(/* webpackChunkName: "Login" */ "./containers/Login/Login"));
const Chat = asyncComponentLoader(() => import(/* webpackChunkName: "Chat" */ "./components/Chat"));
const Orders = asyncComponentLoader(() =>
  import(/* webpackChunkName: "Orders" */ "./containers/Orders/Orders"));
const Profile = asyncComponentLoader(() =>
  import(/* webpackChunkName: "Profile" */ "./components/Profile"));
const Settings = asyncComponentLoader(() =>
  import(/* webpackChunkName: "Settings" */ "./containers/Settings/Settings"));
const SettingsAdmins = asyncComponentLoader(() =>
  import(/* webpackChunkName: "SettingsAdmins" */ "./containers/Settings/SettingsAdmins"));
const DeliverySettings = asyncComponentLoader(() =>
  import(/* webpackChunkName: "DeliverySettings" */ "./containers/Settings/DeliverySettings"));
const PaymentSettings = asyncComponentLoader(() =>
  import(/* webpackChunkName: "PaymentSettings" */ "./containers/Settings/PaymentSettings"));
const CommissionSettings = asyncComponentLoader(() =>
  import(/* webpackChunkName: "CommissionSettings" */ "./containers/Settings/CommissionSettings"));
const VenueMenu = asyncComponentLoader(() =>
  import(/* webpackChunkName: "VenueMenu" */ "./containers/VenueMenu/VenueMenu"));
const Dashboard = asyncComponentLoader(() =>
  import(/* webpackChunkName: "Dashboard" */ "./containers/Dashboard/Dashboard"));
const Mailing = asyncComponentLoader(() =>
  import(/* webpackChunkName: "Mailing" */ "./components/Mailing"));
const PositionStats = asyncComponentLoader(() =>
  import(/* webpackChunkName: "PositionStats" */ "./components/PositionStats"));
const CorpMenus = asyncComponentLoader(() =>
  import(/* webpackChunkName: "CorpMenu" */ "./components/CorpMenus"));
const TryOut = asyncComponentLoader(() =>
  import(/* webpackChunkName: "TryOut" */ "./containers/TryOut/TryOut"));
const LoyaltyProgram = asyncComponentLoader(() =>
  import(/* webpackChunkName: "LoyaltyProgram" */ "./containers/LoyaltyProgram/LoyaltyProgram"));
const LoyaltyProgramHistory = asyncComponentLoader(() =>
  import(/* webpackChunkName: "LoyaltyHistory" */ "./containers/LoyaltyProgram/LoyaltyProgramHistory"));
const LoyaltyProgramStats = asyncComponentLoader(() =>
  import(/* webpackChunkName: "LoyaltyProgramStats" */ "./containers/LoyaltyProgram/LoyaltyProgramStats"));
const LoyaltyProgramNetworkStats = asyncComponentLoader(() =>
  import(/* webpackChunkName: "LoyaltyProgramNetworkStats" */ "./containers/LoyaltyProgram/LoyaltyProgramNetworkStats"));
const SelfBoarding = asyncComponentLoader(() =>
  import(/* webpackChunkName: "SelfBoarding" */ "./containers/SelfBoarding/SelfBoarding"));
const ItemFeedbacks = asyncComponentLoader(() =>
  import(/* webpackChunkName: "ItemFeedbacks" */ "./containers/Feedbacks/ItemFeedbacks"));
const ItemFeedbacksPositions = asyncComponentLoader(() =>
  import(/* webpackChunkName: "ItemFeedbacksPositions" */ "./containers/Feedbacks/ItemFeedbacksPositions"));
const VenueFeedbacks = asyncComponentLoader(() =>
  import(/* webpackChunkName: "VenueFeedbacks" */ "./containers/Feedbacks/VenueFeedbacks"));
const LunchMenu = asyncComponentLoader(() =>
  import(/* webpackChunkName: "LunchMenu" */ "./containers/LunchMenu/LunchMenu"));
const LunchEditor = asyncComponentLoader(() =>
  import(/* webpackChunkName: "LunchEditor" */ "./containers/LunchEditor/LunchEditor"));

moment.locale(window.navigator.userLanguage || window.navigator.language);

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: pompadour,
    primary2Color: pompadour,
  },
});

const LangButton = styled.button`
  padding: 5px;
  margin: 0;
  margin-left: 25px;
  cursor: pointer;
  border: 2px solid white;
  border-radius: 5px;
  font-weight: bold;
  background-color: transparent;
  color: white;
  text-transform: uppercase;
`;

class App extends Component {
  static getSectionByPath(pathname) {
    if (_.findIndex(MenuItems, ["route", pathname]) !== -1) {
      return _.find(MenuItems, ["route", pathname]).name;
    }
    for (let i = 0; i < MenuItems.length; i += 1) {
      if (_.findIndex(MenuItems[i].items, ["route", pathname]) !== -1) {
        return _.find(MenuItems[i].items, ["route", pathname]).name;
      }
    }
    return "";
  }

  constructor(props) {
    super(props);
    this.state = {
      openNavigationMenu: false,
      openDialog: false,
      eventFeedDrawer: false,
    };
    this.setLanguage("ru");
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      ReactGA.pageview(window.location.pathname + window.location.search);
      let action = "";
      let category = "";
      const venueId = window.store.getState().settings.venue_id;
      switch (nextProps.location.pathname) {
        case "/":
          category = "Navigation";
          action = "login_opened";
          break;
        case "/dashboard":
          category = "Navigation";
          action = "dashboard_opened";
          break;
        case "/guests":
          category = "Navigation";
          action = "guests_opened";
          break;
        case "/meals":
          category = "Navigation";
          action = "lunches_opened";
          break;
        case "/chats":
          category = "Navigation";
          action = "chats_opened";
          break;
        case "/orders":
          category = "Navigation";
          action = "orders_opened";
          break;
        case "/newLunch":
          category = "Lunch";
          action = "lunch_create_pressed";
          break;
        case "/menu":
          category = "Navigation";
          action = "venue_menu_opened";
          break;
        default:
          action = "";
      }
      if (action) {
        ReactGA.event({
          category,
          action,
          dimension1: venueId,
        });
      }
    }
  }

  setLanguage = (languageCode) => {
    moment.locale(languageCode);
    this.props.i18n.changeLanguage(languageCode);
  };

  checkOnboarding() {
    const onboarding = localStorage.getItem(this.props.location.pathname);
    if (!onboarding) {
      this.setState({ openDialog: true });
    }
  }

  finishOnboarding() {
    localStorage.setItem(this.props.location.pathname, "true");
  }

  showHint() {
    this.setState({ openDialog: !this.state.openDialog });
  }

  render() {
    const { openNavigationMenu, openDialog, eventFeedDrawer } = this.state;
    const {
      isAuth, venueName, history, location, registerStatus, venueIcon,
    } = this.props;

    if (!isAuth) {
      return (
        <MuiThemeProvider muiTheme={muiTheme}>
          <Login />
        </MuiThemeProvider>
      );
    }

    if (registerStatus !== "finished" && location.pathname !== "/selfboarding") {
      return <Redirect to="/selfboarding" />;
    } else if (location.pathname === "/selfboarding" && registerStatus === "finished") {
      return <Redirect to="/dashboard" />;
    }

    const actions = [
      <FlatButton
        label="Понятно"
        primary
        onClick={() => {
          this.finishOnboarding();
          this.showHint();
        }}
      />,
    ];

    const subMenu = _.find(Object.keys(SubMenuItems), item =>
      window.location.pathname.includes(item));
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="App">
          <Dialog
            actions={actions}
            modal={false}
            open={openDialog}
            onRequestClose={() => {
              this.showHint();
            }}
          >
            {Hints[location.pathname]}
          </Dialog>
          <DashboardEventFeed
            onRequestClose={() => this.setState({ eventFeedDrawer: false })}
            isDashboard={
              this.props.location.pathname === "/dashboard" && document.body.offsetWidth > 1000
            }
            open={eventFeedDrawer}
          />
          <AsapAppBar
            leftContent={
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <IconButton
                  onClick={() => {
                    ReactGA.event({
                      category: "Navigation",
                      action: "navigation_menu_opened",
                    });
                    this.setState({ openNavigationMenu: !openNavigationMenu });
                  }}
                >
                  <Menu color="white" />
                </IconButton>
                <AsapAvatar style={{ marginRight: 20, marginLeft: 20 }} photo={venueIcon} />
                {venueName}
                {Hints[location.pathname] && (
                  <IconButton
                    style={{ padding: 0, height: "100%", verticalAlign: "text-bottom" }}
                    tooltipPosition="middle-right"
                    tooltip="Подсказка"
                    onClick={() => this.showHint()}
                  >
                    <Help color="white" />
                  </IconButton>
                )}
                {false && (
                  <LangButton onClick={() => this.setLanguage(this.props.t("otherLanguageCode"))}>
                    {this.props.t("otherLanguageCode")}
                  </LangButton>
                )}
              </div>
            }
            content={<SupportChat />}
            contentStyle={{ textAlign: "center", alignSelf: "flex-start" }}
            rightContent={
              <Alert onClick={() => this.setState({ eventFeedDrawer: true })} color="white" />
            }
            fixed
            style={{ zIndex: 10000 }}
          />
          <AsapDrawer
            style={{ zIndex: 1 }}
            open={openNavigationMenu}
            onRequestClose={() => this.setState({ openNavigationMenu: false })}
            drawerContainerStyle={{ height: "100%" }}
          >
            <NavigationMenu
              closeDrawer={() => this.setState({ openNavigationMenu: false })}
              history={history}
              items={MenuItems}
            />
          </AsapDrawer>
          <div style={{ marginTop: "64px", marginBottom: "72px" }}>
            {SubMenuItems[subMenu] && (
              <div style={{ padding: "20px", display: "flex", justifyContent: "center" }}>
                <AsapPicker
                  items={SubMenuItems[subMenu]}
                  activeItemIndex={_.findIndex(
                    SubMenuItems[subMenu],
                    item => window.location.pathname === item.key,
                  )}
                  onClickItem={(item) => {
                    history.push(item.key);
                  }}
                />
              </div>
            )}
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/menu/corpmenu" component={CorpMenus} />

              <Route name="meals" path="/menu/meals" component={LunchList} />
              <Route path="/menu/lunch/edit/:lunchId" component={LunchEditor} />
              <Route path="/menu/lunch" component={LunchMenu} />

              <Route path="/menu/try_out" component={TryOut} />

              <Route path="/menu" component={VenueMenu} />
              <Route name="guests" path="/guests" component={Guests} />
              <Route name="chat" path="/chats/:userId" component={Chat} />
              <Route name="chat" path="/chats" component={Chat} />
              <Route name="orders" path="/orders" component={Orders} />
              <Route path="/settings/admins" component={SettingsAdmins} />
              <Route path="/settings/delivery" component={DeliverySettings} />
              <Route path="/settings/payment" component={PaymentSettings} />
              <Route path="/settings/commission" component={CommissionSettings} />
              <Route name="settings" path="/settings" component={Settings} />
              <Route path="/mailing" component={Mailing} />

              <Route path="/editor/:lunchId" component={Editor} />
              <Route path="/newLunch" component={Editor} />
              <Route path="/lunch/:lunchId/:lunchTypeId" component={LunchConstructor} />
              <Route path="/lunch/:lunchId" component={LunchConstructor} />

              <Route path="/profile/:guestId" component={Profile} />
              <Route path="/position/:positionId" component={PositionStats} />
              <Route path="/loyalty/history" component={LoyaltyProgramHistory} />
              <Route path="/loyalty/stats" component={LoyaltyProgramStats} />
              <Route path="/loyalty/network-stats" component={LoyaltyProgramNetworkStats} />
              <Route path="/loyalty" component={LoyaltyProgram} />
              <Route path="/selfboarding" component={SelfBoarding} />
              <Route path="/feedbacks/forvenue" component={VenueFeedbacks} />
              <Route path="/feedbacks/positions" component={ItemFeedbacksPositions} />
              <Route path="/feedbacks" component={ItemFeedbacks} />
            </Switch>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

const Hints = {
  "/gifts": <GiftsHint />,
  "/try": <TryHint />,
};

// TODO (divideby): redesign navigation
const SubMenuItems = {
  "/menu": [
    {
      key: "/menu",
      value: "Меню",
    },
    {
      key: "/menu/meals",
      value: "Ланчи",
    },
    {
      key: "/menu/lunch",
      value: "Новые ланчи",
    },
    {
      key: "/menu/corpmenu",
      value: "Корпоративное меню",
    },
    {
      key: "/menu/try_out",
      value: "Попробуй",
    },
  ],
  "/settings": [
    {
      key: "/settings",
      value: "Общее",
    },
    {
      key: "/settings/admins",
      value: "Администраторы",
    },
    {
      key: "/settings/delivery",
      value: "Доставка",
    },
    {
      key: "/settings/payment",
      value: "Реквизиты",
    },
    {
      key: "/settings/commission",
      value: "Коммиссия",
    },
  ],
  "/feedbacks": [
    {
      key: "/feedbacks",
      value: "По гостям",
    },
    {
      key: "/feedbacks/positions",
      value: "По блюдам",
    },
    {
      key: "/feedbacks/forvenue",
      value: "Оценки заведения",
    },
  ],
  "/loyalty": [
    {
      key: "/loyalty",
      value: "Настройки",
    },
    {
      key: "/loyalty/history",
      value: "История",
    },
    {
      key: "/loyalty/stats",
      value: "Статистика (в заведении)",
    },
    {
      key: "/loyalty/network-stats",
      value: "Статистика (в сети)",
    },
  ],
};

const MenuItems = [
  {
    name: "Дашборд",
    route: "/dashboard",
    rightIcon: <DashboardIcon />,
    items: [],
  },
  {
    name: "Гости",
    route: "/guests",
    rightIcon: <People />,
  },
  {
    name: "Отзывы",
    route: "/feedbacks",
    rightIcon: <ItemFeedbacksIcon />,
  },
  {
    route: "/orders",
    name: "Заказы",
    rightIcon: <Restaurant />,
  },
  {
    route: "/chats",
    name: "Чаты",
    rightIcon: <Message />,
  },
  {
    route: "/loyalty",
    name: "Звездочки",
    rightIcon: <SentimentVerySatisfied />,
  },
  {
    route: "/menu",
    name: "Меню",
    rightIcon: <MenuIcon />,
  },
  {
    route: "/settings",
    name: "Настройки",
    rightIcon: <Gear />,
  },
];

function mapStateToProps(state) {
  return {
    isAuth: state.auth,
    venueName: state.venue.name,
    venueIcon: state.venue.icon,
    registerStatus: state.venue.registerStatus,
    unreadMessagesCount: _.sumBy(state.chats, "unreadMessagesCount"),
  };
}

export default withRouter(connect(mapStateToProps)(translate()(App)));



// WEBPACK FOOTER //
// ./src/App.js